import React from 'react';
import './MyProgressBar.css';

function MyProgressBar({ value, max, containerWidth, color, splitAmount }) {
    const percentage = (value / max) * 100;
    const barColorClass = percentage >= 100 ? 'gold' : '';


    const calculateWeeksRemaining = () => {
        if (value >= max) {
            return 'Goal reached!';
        }
        if (splitAmount <= 0) {
            return 'N/A (no weekly contribution)';
        }
        const remaining = max - value;
        const weeksRemaining = Math.ceil(remaining / splitAmount);
        return `${weeksRemaining} week${weeksRemaining !== 1 ? 's' : ''} to goal`;
    };

    const tooltipText = calculateWeeksRemaining();

    return (
        <div className="progress-bar-container" style={{ width: containerWidth || '100%' }}>
            <div 
                className={`progress-bar ${barColorClass}`} 
                style={{ 
                    width: `${Math.min(percentage, 100)}%`,
                    backgroundColor: color || ''
                }} 
                data-tooltip={tooltipText}
            >
                {percentage.toFixed(0)}%
            </div>
        </div>
    );
}

export default MyProgressBar;